module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto-v15-latin-regular.woff
// module id = 962
// module chunks = 7